import Vue from 'vue';
// import sys from '@/services/system';
import { httpAPI, errorHandler } from "@/api/httpAPI";
import CryptoJS from 'crypto-js'
import i18n from '@/i18n';

function hashData(data) {
    return CryptoJS.MD5(JSON.stringify(data)).toString()
}

const dynamictable = {
    namespaced: true,
    state: {
        isPending: false,
        dataSource: null,
        dataSourceHash: 0,
        periodicity: null,
        classifierId: null,
        periodDate: null,
        periodYear: null,
        periodValue: null,
        dataKey: 0,
        allowImport: false,
        isDataChanged: false        
    },
    mutations: {
        SET_IS_PENDING(state, payload) {
            state.isPending = payload;
        },
        SET_DATASOURCE(state, payload) {
            state.dataSource = payload;            
        },
        SET_DATASOURCE_HASH(state, payload) {
            state.dataSourceHash = payload;            
        },
        SET_IS_DATA_CHANGED(state, payload) {
            state.isDataChanged = payload;            
        },
        SET_PERIODICITY(state, payload) {
            state.periodicity = payload;  
        },
        SET_CLASSIFIER_ID(state, payload) {
            state.classifierId = payload;  
        },
        SET_PERIOD_DATE(state, payload) {
            state.periodDate = payload;  
        },
        SET_PERIOD_YEAR(state, payload) {
            state.periodYear = payload;  
        },
        SET_PERIOD_VALUE(state, payload) {
            state.periodValue = payload;  
        },
        SET_DATA_KEY(state) {
            state.dataKey +=1;            
        },
        SET_ALLOW_IMPORT(state, payload){
            state.allowImport = payload;
        },
        UPDATE_DATASOURCE(state, payload) {                             
            if (!this._vm.$_.has(state.dataSource, payload.property)) 
                Vue.set(state.dataSource, payload.property, payload.value)
            else
                this._vm.$_.set(state.dataSource, payload.property, payload.value)

            if (!state.isPending) {
                state.isDataChanged = state.dataSourceHash != hashData(state.dataSource);
            }
        },
        ADD_ROW_DATASOURCE(state, payload) {
            state.dataSource.rows.push(payload);
        }
    },
    actions: {
        async ok({ state, commit }) {
            
            commit('SET_IS_PENDING', true);

            let items = state.dataSource.cols;
            let dataCols = items.filter(i => !Array.isArray(i.items) || i.items.length == 0);
            let hasNextLevel = true;

            while(hasNextLevel) {
                items = items.reduce((acc, item) => {
                        item.items?.forEach(i => acc.push(i));
                    return acc;
                }, []);

                hasNextLevel = items.length > 0;
                
                items.filter(i => !Array.isArray(i.items) || i.items.length == 0).forEach(i => dataCols.push(i));
            } 
            
            let values = state.dataSource.rows.reduce((a, r) => {

                if (r.readonly)
                    return a;

                let dataRow = { RegionId: r.id };

                dataRow.Value = r.data.reduce((ra, rd, ri) => {

                    if (dataCols[ri].type)
                        ra[dataCols[ri].id] = rd;

                    return ra;
                }, {});

                a.push(dataRow);

                return a;

            }, []);

            let data = {
                ClassifierId: state.classifierId,
                Date: state.periodDate ?? this._vm.$moment("2025-04-11T07:27:41.852Z").utc(),
                Year: state.periodicity == 1 ? state.periodValue : state.periodYear ?? 0,
                PeriodValue: state.periodicity == 7 ? this._vm.$moment(state.periodDate).dayOfYear() :  state.periodValue ?? 0,
                Values: values
            }

            let response = await httpAPI({ 
                url: ` situation-center/classifiers/set-value`, 
                method: 'POST', 
                data: data
            });

            if(response) {
                this._vm.$notify.success('Данные сохранены!');
                commit('SET_DATASOURCE_HASH', hashData(state.dataSource));
                commit('SET_IS_DATA_CHANGED', false);
            }
            else
                this._vm.$notify.alert('Данные не сохранены!');

            commit('SET_IS_PENDING', false);
        },
        updateDataSource({ commit }, data) {
            commit('UPDATE_DATASOURCE', data);
        },
        async getSchema({ commit, dispatch }, id) {
            
            if (!id)
                return;
            
            commit('SET_CLASSIFIER_ID', id);
            commit('SET_ALLOW_IMPORT', false);
            commit('SET_IS_PENDING', true);

            //let response = await httpAPI({ url: `situation-center/classifiers/get-schema/${id}`, method: 'GET', skipErrorHandler: true });

            //let sourceData = response.data;
            let sourceData = {
                "nameRu": "add rows",
                "nameKz": "add rows",
                "periodicity": 1,
                "regions": [
                    {
                        "id": 15,
                        "nameRu": "Северо-Казахстанская область",
                        "nameKz": ""
                    }
                ],
                "properties": [
                    {
                        "id": "country",
                        "type": "String",
                        "titleRu": "Страна",
                        "titleKz": "Страна"
                    },
                    {
                        "id": "income",
                        "type": "Number",
                        "titleRu": "Прибыло",
                        "titleKz": "Прибыло"
                    },
                    {
                        "id": "outcome",
                        "type": "Number",
                        "titleRu": "Убыло",
                        "titleKz": "Убыло"
                    }
                ]
            };


            let data = {};

            commit('SET_PERIODICITY', sourceData.periodicity);
            commit('SET_PERIOD_DATE', null);
            commit('SET_PERIOD_YEAR', null);
            commit('SET_PERIOD_VALUE', null);

            data.title = {
                kk: sourceData.nameKz,
                ru: sourceData.nameRu
            };

            data.rows = sourceData.regions.reduce((a, v) => {
                let item = { id: v.id };
                item.data = [];
                //item.data.push({ kk: v.nameKz, ru: v.nameRu })
                sourceData.properties.forEach(() => {item.data.push(null)});

                a.push(item);
                return a;
            }, []);

            data.cols = [                
                // {
                //     title: {
                //         kk: "Регионы",
                //         ru: "Регионы"
                //     },
                //     items: []					
                // }
            ];

            sourceData.properties.forEach((v) => {
                data.cols.push(
                    {
                        id: v.id,
                        title: {
                            kk: v.titleKz,
                            ru: v.titleRu
                        },
                        items: [],
                        type: v.type == "Number" ? "number" : "text"
                    },
                );
            });

            commit('SET_DATASOURCE', data);
            commit('SET_IS_PENDING', false);
            if (sourceData.periodicity == 0)
                dispatch('getData');
        },
        async getData({ state, commit }) {

            if (!state.periodValue && state.periodicity > 0)
                return;
            commit('SET_IS_PENDING', true);
            let data = {
                ClassifierId: state.classifierId,                
                Year: state.periodicity == 1 ? state.periodValue : state.periodYear ?? 0,
                PeriodValue: state.periodicity == 7 ? this._vm.$moment(state.periodDate).dayOfYear() :  state.periodValue ?? 0,
            };

            let response = await httpAPI({ 
                url: `situation-center/classifiers/get-value-with-period`, 
                method: 'POST', 
                data: data
            }); 

            if (response) {
                                
                if (response.data?.Values && Array.isArray(response.data?.Values) && response.data?.Values.length > 0){
                    response.data.Values.forEach((i) => {

                        let row = state.dataSource.rows.find(r => r.id == i.RegionId);

                        if (!row) 
                            return;

                        let rowIndex = state.dataSource.rows.indexOf(row);

                        for (const [key, value] of Object.entries(i.Value)) {
                            let col = state.dataSource.cols.find(c => c.id == key);
                            if (col) {
                                let colIndex = state.dataSource.cols.indexOf(col);
                                commit('UPDATE_DATASOURCE', { property: `rows[${rowIndex}].data[${colIndex}]`, value: value });
                            }
                        }                    
                    });
                    if (response.data.Period)
                        commit('SET_PERIOD_DATE', response.data.Period.BeginDate);
                }
                else {
                    for (let i = 0; i < state.dataSource.rows.length; i++ ){
                        for (let j = 1; j < state.dataSource.cols.length; j++ ){
                            commit('UPDATE_DATASOURCE', { property: `rows[${i}].data[${j}]`, value: null });
                        }
                    }
                }
                
                commit('SET_DATASOURCE_HASH', hashData(state.dataSource));
                commit('SET_IS_DATA_CHANGED', false);
                commit('SET_DATA_KEY');
            }
            
            commit('SET_IS_PENDING', false);
        },
        async importData({ state, commit }, {dataFile}) {

            let onResolve = (response) => {
                response.data.forEach((i) => {
                    let row = state.dataSource.rows.find(r => r.id == i.RegionId);
                    if (!row) 
                        return;

                    let rowIndex = state.dataSource.rows.indexOf(row);

                    for (const [key, value] of Object.entries(i.Value)) {
                        let col = state.dataSource.cols.find(c => c.id == key);
                        if (col) {
                            let colIndex = state.dataSource.cols.indexOf(col);
                            commit('UPDATE_DATASOURCE', { property: `rows[${rowIndex}].data[${colIndex}]`, value: value });
                        }
                    }                    
                });

                commit('SET_DATASOURCE_HASH', hashData(state.dataSource));
                commit('SET_IS_DATA_CHANGED', true);
                commit('SET_DATA_KEY');
                commit('SET_IS_PENDING', false);
                this._vm.$notify.success("Данные_получены");
            };

            let onReject = (error) => {
                
                errorHandler(error);
                commit('SET_IS_PENDING', false);
            };

            let importFil = (dataFile) => {
                commit('SET_IS_PENDING', true);
                let formData = new FormData();
                formData.append('file', dataFile );
                let request = httpAPI.post(`situation-center/import?classifierId=${state.classifierId}&year=${state.periodicity == 0 ? 0 : state.periodYear}&period=${state.periodicity == 0 ? 0 : state.periodValue}`, formData, { headers: {"Content-Type": "multipart/form-data"}, skipErrorHandler: true  });
                this._vm.$notify.async(request, onResolve, onReject, "Импорт_данных", { icons: { enabled: true } });
            }

            if (state.isDataChanged){
                this._vm.$notify.confirm(
                    i18n.t('Есть_не_сохраненные_данные_которые_при_импорте_будут_утеряны_Продолжить?'),
                    async () => { importFil(dataFile); }
                )
            }
            else 
                importFil(dataFile);

        },
        async exportClassifier({ state }){
            let onResolve = (response) => {

                let filename = "Export.xlsx";
                let headerLine = response.headers['content-disposition'];

                if (headerLine) {
                    let token = headerLine.split(';').map(t => t.trim()).find(t => t.startsWith("filename*=UTF-8"));

                    if (token)
                        filename = decodeURIComponent(token.replace("filename*=UTF-8''", ""));
                }

                this._vm.$notify.success("Экспорт_выполнен");
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            };

            let onReject = (error) => {
                errorHandler(error);
            };

            let data = {
                ClassifierId: state.classifierId,                
                Year: state.periodicity == 1 ? state.periodValue : state.periodYear ?? 0,
                PeriodValue: state.periodicity == 7 ? this._vm.$moment(state.periodDate).dayOfYear() :  state.periodValue ?? 0,
            };

            let request = httpAPI.post(`/situation-center/classifiers/export`, data, { responseType: 'blob', skipErrorHandler: true });

            this._vm.$notify.async(request, onResolve, onReject, "Экспорт_данных", { icons: { enabled: true } });
        },
        addRowDataSource({ commit }, newRow) {
            commit('ADD_ROW_DATASOURCE', newRow);
          }   
    },
    getters: {
        isPending: (s) => s.isPending,
        dataSource: (s) => s.dataSource,
        date: (s) => s.date,
        getPeriodicity: (s) => s.periodicity,
        getPeriodDate: (s) => s.periodDate,
        getPeriodYear: (s) => s.periodYear,
        getPeriodValue: (s) => s.periodValue,
        getDataKey: (s) => s.dataKey,
        getAllowImport: (s) => s.classifierId && s.allowImport,
        isExportAllow: (s) => !!s.classifierId && !!s.periodValue && (s.periodicity == 1 || s.periodYear),
        isDataChanged: (s) => s.isDataChanged
    }
}

export default dynamictable;